import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Banner global, blocant vizual dar nu functional — apare peste orice ecran cand
// backend-ul respinge o cerere cu 402 (licenta invalida/lipsa/expirata). Fara el,
// utilizatorul vede doar liste goale/erori tacute, fara sa inteleaga de ce.
export default function LicenseErrorBanner() {
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isSuperAdmin = user?.rol === 'superadmin';

  useEffect(() => {
    function onLicenseError(e) { setMessage(e.detail); }
    window.addEventListener('license-error', onLicenseError);
    return () => window.removeEventListener('license-error', onLicenseError);
  }, []);

  // Reseteaza automat cand adminul chiar ajunge pe ecranul de licenta, ca sa nu
  // ramana banner-ul peste formularul in care tocmai introduce tokenul nou.
  useEffect(() => {
    if (location.pathname === '/admin' && location.search.includes('tab=licenta')) {
      setMessage(null);
    }
  }, [location]);

  if (!message) return null;

  return (
    // Nu "position: fixed" — headerul paginilor (cu Layout) e "sticky top:0" si
    // contine butonul de meniu pe mobil; un banner fixed peste el ar bloca accesul
    // la navigare. In flux normal, impinge pur si simplu continutul in jos.
    <div style={{
      background: '#B84A3F', color: '#fff', padding: '10px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14,
      flexWrap: 'wrap', textAlign: 'center',
      fontSize: 13, fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(0,0,0,.15)',
    }}>
      <span>⚠ Licență invalidă — {message}</span>
      {isSuperAdmin && (
        <button
          onClick={() => navigate('/admin?tab=licenta')}
          style={{
            background: '#fff', color: '#B84A3F', border: 'none', borderRadius: 6,
            padding: '4px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          Configurează licența
        </button>
      )}
    </div>
  );
}
